module.exports = __webpack_public_path__ + "static/media/Header3.8492e345.jpg";